export const REGEX = {
    UPPERCASE: /[A-Z]/,
    SPECIAL_CHAR: /\W/,
    DIGIT: /\d/,
    NUMERIC_ONLY: /[^0-9.-]+/g,
    NUMBER: /^[0-9]*$/,
    PHONENUMBER: /^[0-9]{4,15}$/,
    PHONENUMBERWITHPHONECODE: /^\+[0-9]{1,3}\s[0-9]{4,15}$/,
    FULLNAME: /^[\p{L}]+(?: [\p{L}]+)+$/u,
    // Strict (khớp Keycloak): cấm dấu chấm đôi/đầu/cuối ở local + domain (vd "lms..dev" -> báo lỗi, không lọt xuống 500)
    EMAIL: /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?)+$/,
    YOUTUBELINK: /^(?:https?:\/\/)?(?:www\.|m\.)?(?:youtube\.com\/(?:watch\?.*v=|embed\/|shorts\/|live\/|v\/|vi\/|user\/.*#p\/.*\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})(?:[&?\/#].*)?$/,
    ID: /^[A-Za-z0-9]{3,}$/,
}

export const DateTimeRegex = {
  // Format: M/d/yyyy h:mm:ss AM/PM (8/27/2025 7:00:00 AM)
  MDyyyyHmmssAMPM: /(\d{1,2}\/\d{1,2}\/\d{4}\s+\d{1,2}:\d{2}:\d{2}\s+[AP]M)/gi,
  
  // Format: M/d/yyyy h:mm AM/PM (8/27/2025 7:00 AM)
  MDyyyyHmmAMPM: /(\d{1,2}\/\d{1,2}\/\d{4}\s+\d{1,2}:\d{2}\s+[AP]M)/gi,
  
  // Format: MM/dd/yyyy HH:mm:ss (08/27/2025 07:00:00)
  MMDDyyyyHHmmss: /(\d{2}\/\d{2}\/\d{4}\s+\d{2}:\d{2}:\d{2})/gi,
  
  // Format: MM/dd/yyyy HH:mm (08/27/2025 07:00)
  MMDDyyyyHHmm: /(\d{2}\/\d{2}\/\d{4}\s+\d{2}:\d{2})/gi,
  
  // Format: yyyy-MM-dd HH:mm:ss (2025-08-27 07:00:00)
  yyyyMMddHHmmss: /(\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2})/gi,
  
  // Format: yyyy-MM-dd HH:mm (2025-08-27 07:00)
  yyyyMMddHHmm: /(\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2})/gi,
  
  // Format: dd/MM/yyyy HH:mm:ss (27/08/2025 07:00:00)
  ddMMyyyyHHmmss: /(\d{2}\/\d{2}\/\d{4}\s+\d{2}:\d{2}:\d{2})/gi,
  
  // Format: dd/MM/yyyy HH:mm (27/08/2025 07:00)
  ddMMyyyyHHmm: /(\d{2}\/\d{2}\/\d{4}\s+\d{2}:\d{2})/gi,
  
  // Format: dd-MM-yyyy HH:mm:ss (27-08-2025 07:00:00)
  ddMMyyyyHHmmssDash: /(\d{2}-\d{2}-\d{4}\s+\d{2}:\d{2}:\d{2})/gi,
  
  // Format: dd-MM-yyyy HH:mm (27-08-2025 07:00)
  ddMMyyyyHHmmDash: /(\d{2}-\d{2}-\d{4}\s+\d{2}:\d{2})/gi,
  
  // Format: dd MMM yyyy HH:mm:ss (27 Aug 2025 07:00:00)
  ddMMMyyyyHHmmss: /(\d{1,2}\s+[A-Za-z]{3}\s+\d{4}\s+\d{2}:\d{2}:\d{2})/gi,
  
  // Format: dd MMM yyyy HH:mm (27 Aug 2025 07:00)
  ddMMMyyyyHHmm: /(\d{1,2}\s+[A-Za-z]{3}\s+\d{4}\s+\d{2}:\d{2})/gi,
  
  // Format: dd MMMM yyyy HH:mm:ss (27 August 2025 07:00:00)
  ddMMMMyyyyHHmmss: /(\d{1,2}\s+[A-Za-z]+\s+\d{4}\s+\d{2}:\d{2}:\d{2})/gi,
  
  // Format: dd MMMM yyyy HH:mm (27 August 2025 07:00)
  ddMMMMyyyyHHmm: /(\d{1,2}\s+[A-Za-z]+\s+\d{4}\s+\d{2}:\d{2})/gi,
  
  // Format: MMM dd, yyyy HH:mm:ss (Aug 27, 2025 07:00:00)
  MMMddyyyyHHmmss: /([A-Za-z]{3}\s+\d{1,2},\s+\d{4}\s+\d{2}:\d{2}:\d{2})/gi,
  
  // Format: MMM dd, yyyy HH:mm (Aug 27, 2025 07:00)
  MMMddyyyyHHmm: /([A-Za-z]{3}\s+\d{1,2},\s+\d{4}\s+\d{2}:\d{2})/gi,
  
  // Format: MMMM dd, yyyy HH:mm:ss (August 27, 2025 07:00:00)
  MMMMddyyyyHHmmss: /([A-Za-z]+\s+\d{1,2},\s+\d{4}\s+\d{2}:\d{2}:\d{2})/gi,
  
  // Format: MMMM dd, yyyy HH:mm (August 27, 2025 07:00)
  MMMMddyyyyHHmm: /([A-Za-z]+\s+\d{1,2},\s+\d{4}\s+\d{2}:\d{2})/gi,
  
  // Format: yyyy/MM/dd HH:mm:ss (2025/08/27 07:00:00)
  yyyyMMddHHmmssSlash: /(\d{4}\/\d{2}\/\d{2}\s+\d{2}:\d{2}:\d{2})/gi,
  
  // Format: yyyy/MM/dd HH:mm (2025/08/27 07:00)
  yyyyMMddHHmmSlash: /(\d{4}\/\d{2}\/\d{2}\s+\d{2}:\d{2})/gi,
  
  // Format: yyyy-MM-ddTHH:mm:ssZ (2025-08-27T07:00:00Z)
  yyyyMMddTHHmmssZ: /(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z?)/gi,
  
  // Format: yyyy-MM-ddTHH:mm:ss+HH:mm (2025-08-27T07:00:00+07:00)
  yyyyMMddTHHmmssOffset: /(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[+-]\d{2}:\d{2})/gi,
  
  // Format: Unix timestamp (1724720400)
  UnixTimestamp: /(\b\d{10}\b)/gi,
  
  // Format: Millisecond timestamp (1724720400000)
  MillisecondTimestamp: /(\b\d{13}\b)/gi,
  
  // All datetime patterns combined
  AllPatterns: [
    /(\d{1,2}\/\d{1,2}\/\d{4}\s+\d{1,2}:\d{2}:\d{2}\s+[AP]M)/gi,
    /(\d{1,2}\/\d{1,2}\/\d{4}\s+\d{1,2}:\d{2}\s+[AP]M)/gi,
    /(\d{1,2}\/\d{1,2}\/\d{4}\s+\d{1,2}:\d{2}(?::\d{2})?\s*[+-]\d{2}:\d{2})/gi,
    /(\d{2}\/\d{2}\/\d{4}\s+\d{2}:\d{2}:\d{2})/gi,
    /(\d{2}\/\d{2}\/\d{4}\s+\d{2}:\d{2})/gi,
    /(\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2})/gi,
    /(\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2})/gi,
    /(\d{2}\/\d{2}\/\d{4}\s+\d{2}:\d{2}:\d{2})/gi,
    /(\d{2}\/\d{2}\/\d{4}\s+\d{2}:\d{2})/gi,
    /(\d{2}-\d{2}-\d{4}\s+\d{2}:\d{2}:\d{2})/gi,
    /(\d{2}-\d{2}-\d{4}\s+\d{2}:\d{2})/gi,
    /(\d{1,2}\s+[A-Za-z]{3}\s+\d{4}\s+\d{2}:\d{2}:\d{2})/gi,
    /(\d{1,2}\s+[A-Za-z]{3}\s+\d{4}\s+\d{2}:\d{2})/gi,
    /(\d{1,2}\s+[A-Za-z]+\s+\d{4}\s+\d{2}:\d{2}:\d{2})/gi,
    /(\d{1,2}\s+[A-Za-z]+\s+\d{4}\s+\d{2}:\d{2})/gi,
    /([A-Za-z]{3}\s+\d{1,2},\s+\d{4}\s+\d{2}:\d{2}:\d{2})/gi,
    /([A-Za-z]{3}\s+\d{1,2},\s+\d{4}\s+\d{2}:\d{2})/gi,
    /([A-Za-z]+\s+\d{1,2},\s+\d{4}\s+\d{2}:\d{2}:\d{2})/gi,
    /([A-Za-z]+\s+\d{1,2},\s+\d{4}\s+\d{2}:\d{2})/gi,
    /(\d{4}\/\d{2}\/\d{2}\s+\d{2}:\d{2}:\d{2})/gi,
    /(\d{4}\/\d{2}\/\d{2}\s+\d{2}:\d{2})/gi,
    /(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z?)/gi,
    /(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[+-]\d{2}:\d{2})/gi,
    /(\b\d{10}\b)/gi,
    /(\b\d{13}\b)/gi
  ]
};